import { ICourseStructureCategoryQuery } from '../interfaces/course-structure-category.query.interface';

// @dynamic
export class CourseStructureCategory {
    id: string;
    name: string;
    type: string;
    sort: number;
    parent?: {
        id: string;
        name: string;
        type: string;
        sort: number;
    };
    isSelected?: boolean;
    open?: boolean;
    children?: CourseStructureCategory[];
    isSelectable?: boolean;

    constructor(query?: ICourseStructureCategoryQuery) {
        if (query) {
            this.id = query.id?.toString();
            this.name = query.name;
            this.type = query.type;
            this.sort = query.sort;
            this.parent = query.parent
                ? {
                      id: String(query.parent.id),
                      name: query.parent.name,
                      type: query.parent.type,
                      sort: query.parent.sort,
                  }
                : null;
        } else {
            this.id = null;
            this.name = null;
            this.type = null;
            this.sort = null;
            this.parent = null;
        }
    }
}
